import styled, { css } from 'styled-components'

const radioSize = '24px'

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => `${props.theme.spacing.sp12} ${props.theme.spacing.sp16}`};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  border-radius: ${props => props.theme.spacing.sp8};
  background-color: ${props => props.theme.colors.background.primary};
  cursor: pointer;
  transition:
    border-color ease 0.2s,
    background-color ease 0.2s;

  &:hover {
    border-color: ${props => props.theme.colors.text.muted};
  }

  ${props =>
    props.selected &&
    css`
      border-color: ${props.theme.colors.outline.default};
    `}
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp12};
  color: ${props => props.theme.colors.text.default};
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: ${props => props.theme.spacing.sp4};
`

export const AlertSlot = styled.div`
  padding-left: calc(${radioSize} + ${props => props.theme.spacing.sp12});
`
